import React from 'react';
import '../styles/Modal.css';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-content-left-align">
          <h3>{message}</h3>
          <p>Check the status of the tenant by clicking the "Check Status" button.</p>
          <p>Tenant creation normally takes <u>30-60 minutes</u>.  Insights dashboards will take another <u>30-60 minutes</u> after tenant creation to be functional.</p>
          <p>When the status is "completed_creation" the tenant can be accessed at <a href="https://demoprod.otprivacy.com" target="_blank">https://demoprod.otprivacy.com</a> using your <u>otprivacy.com</u> email address and password.</p>
          <p><u>Reminder</u>:  If you have multiple tenants, you will need to switch to this tenant in the platform to access it.</p>
        </div>
        <div className="modal-buttons">
          <button className="btn btn-primary" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;